/* eslint-disable react/prop-types */
import React, { useState } from "react";
import "./resizer.m.css";

function Resizer({ story }) {
  const [active, setActive] = useState("medium");

  const handleFontSize = (value) => {
    const storyBody = document.getElementById(`story-content-${story.id}`);
    setActive(value);
    if (storyBody.classList.contains("big")) {
      storyBody.classList.remove("big");
    } else if (storyBody.classList.contains("medium")) {
      storyBody.classList.remove("medium");
    } else if (storyBody.classList.contains("small")) {
      storyBody.classList.remove("small");
    }
    storyBody.classList.add(value);
  };

  const activeColor = "#0091AC";
  const notActiveColor = "#DDDEDE";
  const whiteColor = "#FFF";
  const blackColor = "#191B1D";

  return (
    <div styleName="wrapper">
      <div styleName="resizer">
        <button styleName="resizer-button small-font" onClick={() => handleFontSize("small")}>
          <svg width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
              fill={active === "small" ? activeColor : notActiveColor}
            />
            <path
              d="M9 15.497H10.376L10.943 13.901H13.799L14.345 15.497H15.825L13.064 8H11.782L9 15.497ZM11.331 12.704L12.36 9.701H12.381L13.399 12.704H11.331Z"
              fill={active === "small" ? whiteColor : blackColor}
            />
          </svg>
        </button>
        <button styleName="resizer-button medium-font" onClick={() => handleFontSize("medium")}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
              fill={active === "medium" ? activeColor : notActiveColor}
            />
            <path
              d="M8.25 16.068H9.822L10.47 14.244H13.734L14.358 16.068H16.05L12.894 7.5H11.43L8.25 16.068ZM10.914 12.876L12.09 9.444H12.114L13.278 12.876H10.914Z"
              fill={active === "medium" ? whiteColor : blackColor}
            />
          </svg>
        </button>
        <button styleName="resizer-button big-font" onClick={() => handleFontSize("big")}>
          <svg width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path
                d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
                fill={active === "big" ? activeColor : notActiveColor}
              />
              <path
                d="M8 16.639H9.769L10.497 14.587H14.17L14.872 16.639H16.776L13.225 7H11.578L8 16.639ZM10.997 13.048L12.32 9.187H12.347L13.657 13.048H10.997Z"
                fill={active === "big" ? whiteColor : blackColor}
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Resizer;
